// Documentation: https://www.twilio.com/docs/voice/sdks/javascript/twiliodevice#instantiate-a-device
import { Device } from "@twilio/voice-sdk";

let device;
let call;

// Handle unhandled promise rejections from Twilio SDK's internal setSinkId calls
// setSinkId requires a user gesture, but the SDK may call it asynchronously
// This is non-critical - the Device will still work without setting the audio output device
// This error can break other JavaScript functionality, so we must catch it
window.addEventListener("unhandledrejection", function (event) {
  const reason = event.reason || {};
  const errorMessage = reason.message || String(reason) || "";
  const errorName = reason.name || "";
  const stack = reason.stack || String(reason) || "";

  // Check if this is the Twilio setSinkId NotAllowedError
  if (
    errorName === "NotAllowedError" &&
    (errorMessage.includes("user gesture") || errorMessage.includes("gesture"))
  ) {
    // Check if this is from Twilio SDK (sinkId related)
    if (stack.includes("audioplayer") || stack.includes("setSinkId") || stack.includes("@twilio/voice-sdk") || stack.includes("twilio")) {
      event.preventDefault(); // Prevent the error from being logged as unhandled and breaking other code
      // Silently ignore - this is expected behavior when user gesture context is lost
    }
  }
});

window.getTwilioToken = function getTwilioToken () {
  Teamshares.Rails.ajax({
    type: "POST",
    dataType: "script",
    url: "/admin/outbound-calls/token",
    processData: false,
    contentType: false,
    success: function (response) {
      const token = response.token;
      device = new Device(token);
    },
    error: function (_response) {
      // TODO: handle error here
    },
  });
};

window.initiateCall = async function initiateCall (phoneNumber, callId) {
  call = await device.connect({
    params: {
      To: phoneNumber,
      callId,
    },
  });

  call.on("disconnect", function () {
    document.getElementById("call-modal").classList.toggle("hidden");
    Teamshares.Rails.ajax({
      type: "PATCH",
      dataType: "script",
      url: `/admin/outbound_calls/${callId}?number=${phoneNumber}`,
    });
  });
};

window.endCall = function endCall () {
  device.disconnectAll();
};

window.handleMute = function handleMute (isMuted) {
  call.mute(isMuted);
  document.getElementById("unmute-button").classList.toggle("hidden");
  document.getElementById("mute-button").classList.toggle("hidden");
};

window.sendDigit = function sendDigit (digit) {
  call.sendDigits(digit);
};
